import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseServiceReason } from "../_types/case-service-reason";

@Injectable({
    providedIn: 'root',
})
export class CasesServicesReasonsService extends Service<CaseServiceReason> {
    public override type = 'caseServiceReasons';
    public override url = 'attendance/caseServiceReasons';

    caseServiceReasonTypes() {
        let caseServiceReasonTypes = [
            { label: 'Cancelación', value: 'Cancel' },
            { label: 'Cita atrasada', value: 'DelayedDate' }
        ];
        return caseServiceReasonTypes;
    }

    getCaseServiceReasonTypeLabel(value: string) {
        let caseServiceReasonTypes = this.caseServiceReasonTypes();
        let caseServiceReasonType = caseServiceReasonTypes.find(x => x.value == value);
        return caseServiceReasonType?.label;
    }
}
